/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axiosApi from './inteceptor';
import utils from './utils';

const API_ADMIN = `${utils.svcUrl()}lessons`;

export default {
  createLesson: (id, data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/createLesson/${id}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  updateLesson: (id, data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/edit/${id}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getLessons: (id) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/${id}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getLesson: (id) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/getLesson/${id}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  changedisplayPriority: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/update/displayPriority`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getdatafromurl: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/getdatafromurl`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  cloneLesson: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/newLesson/fromExistingLesson`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  deleteLesson: (lessonId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .delete(`${API_ADMIN}/${lessonId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  ReplyTweet: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/create/replyTweet`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
};
